document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-m-clinically-backed]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    initReveal(section);
    initImageModal(section);
  });

  function initReveal(section) {
    var revealItems = section.querySelectorAll('.m-cb-reveal');
    if (!revealItems.length) return;

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initImageModal(section) {
    if (section.dataset.mCbModalInit === 'true') return;
    section.dataset.mCbModalInit = 'true';

    var trigger = section.querySelector('[data-m-cb-trigger]');
    var modal = section.querySelector('[data-m-cb-modal]');
    var modalImage = section.querySelector('[data-m-cb-modal-image]');
    var closeButtons = section.querySelectorAll('[data-m-cb-modal-close]');

    if (!trigger || !modal || !modalImage) return;

    var closeTimer = null;

    function isImageUrl(url) {
      if (!url || url === '#') return false;

      try {
        var parsedUrl = new URL(url, window.location.origin);
        return /\.(avif|bmp|gif|jpe?g|png|svg|webp)(\?.*)?$/i.test(parsedUrl.pathname + parsedUrl.search);
      } catch (error) {
        return /\.(avif|bmp|gif|jpe?g|png|svg|webp)(\?.*)?$/i.test(url);
      }
    }

    function openModal(imageUrl) {
      if (!imageUrl) return;

      clearTimeout(closeTimer);
      modalImage.src = imageUrl;
      modal.hidden = false;

      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        document.body.classList.add('m-cb-modal-open');
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('m-cb-modal-open');

      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        modal.hidden = true;
        modalImage.removeAttribute('src');
      }, 250);
    }

    trigger.addEventListener('click', function (event) {
      var imageUrl = trigger.getAttribute('data-m-cb-image-url') || trigger.getAttribute('href') || '';

      if (!isImageUrl(imageUrl)) return;

      event.preventDefault();
      openModal(imageUrl);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closeModal();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }
});